import { tryAddMultipleRefinements } from '../multipleRefinementsUtils';
const fromEventOperation = (Operator, field, filter) => {
  const operator = Operator.of(field);
  return tryAddMultipleRefinements(operator, field, filter);
};
export { fromEventOperation };